import http from './http'

export default {
  shop: {
    get (id) {
      return http.get('/shop/get', { id: id })
    },
    getList (keyword, pageConfig) {
      return http.get('/shop/getlist', {
        keyword: keyword,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/shop/create', model)
    },
    update (model) {
      return http.post('/shop/update', model)
    },
    delete (id) {
      return http.post('/shop/delete', id)
    }
  },
  device: {
    get (id) {
      return http.get('/shop/device/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/shop/device/getlist', {
        shopid: search.shop,
        stallid: search.stall,
        keyword: search.keyword,
        deviceTypeId: search.deviceType,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getDeviceTypeList () {
      return http.get('/shop/device/getdevicetypelist')
    },
    create (model) {
      return http.post('/shop/device/create', model)
    },
    update (model) {
      return http.post('/shop/device/update', model)
    },
    delete (id) {
      return http.post('/shop/device/delete', id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/shop.js